// removed by extract-text-webpack-plugin
module.exports = {"post":"src-components----Article-module---post---11pmO","initiale":"src-components----Article-module---initiale---2LDiJ","title":"src-components----Article-module---title---1ZJTI","date":"src-components----Article-module---date---2EdNx","excerpt":"src-components----Article-module---excerpt---3_eZr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Article.module.css
// module id = 356
// module chunks = 35783957827783